module.exports = __webpack_public_path__ + "img/65.17e7d708.jpg";